// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a2fad966","513":"ce0a3490","703":"89044994"}[chunkId] + ".chunk.js";
};